import VendNumber, { vn } from 'vend-number'

/**
 * Is a number correctly rounded based on rounding information?
 * @param {number | string | VendNumber} number
 * @param {number | string | VendNumber} rounding
 * @returns boolean
 */
export const isCorrectlyRounded = (
  number: number | string | VendNumber,
  rounding: number | string | VendNumber
): boolean => {
  return vn(number).dividedBy(vn(rounding)).mod(1).eq(0)
}
